<script lang="ts">
	import type { Review } from "@core/schema/Review.js";
	import Formatted from "./common/Formatted.svelte";
	import Media from "./common/Media.svelte";
	import StructuredData from "./common/StructuredData.svelte";

	const { review }: { review: Review } = $props();
</script>

<StructuredData
	data={{
		"@type": "Review",
		author: {
			"@type": "Person",
			name: review.fullName,
		},
		text: review.content,
	}}
/>

<div
	class="backdrop-blur-lg bg-white/50 rounded-xl md:rounded-3xl p-3 md:p-6 gap-3 md:gap-6 flex flex-col w-[12.5rem] md:w-[24rem] h-full"
>
	<div class="flex gap-4">
		<Media
			draggable={false}
			width={96}
			height={96}
			source={review.photo}
			class="size-10 md:size-16 lg:size-20 rounded-full"
			wrapperClass="shrink-0"
			alt="Fotografie"
			sourcesets={{
				"<2xl": [0, 96],
				">2xl": [0, 96],
			}}
		/>
		<div class="flex flex-col gap-0.5 md:gap-2">
			<h2
				class="text-cmcsecondary text-xl/[0.9] md:text-5xl/[0.9] tracking-[0.02em] font-black font-druk-cond uppercase"
			>
				<Formatted text={review.fullName} />
			</h2>
			<span class="text-cmctext font-medium text-2xs/[1] md:text-base/[1] uppercase">{review.companyName}</span>
		</div>
	</div>
	<p class="text-cmctext font-medium text-2xs/[1.4] md:text-sm/[1.4] line-clamp-3 md:line-clamp-4">
		<q><Formatted text={review.content} /></q>
	</p>
</div>
